import { render, staticRenderFns } from "./DropdownDivider.vue?vue&type=template&id=3329ccf7&"
import script from "./DropdownDivider.vue?vue&type=script&lang=js&"
export * from "./DropdownDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports